/**
 * Created by Ning Jiang on 2025-01-08.
 */
import {Emitter} from "pixi-particles";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {ParticlesManager} from "../../../core/particles/ParticlesManager";
import {TweenLite} from "gsap";

export class BackgroundBoostParticles extends PIXI.Container {

    private _NORMAL_configs:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.1
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 6
            },
            "blendMode" : "normal",
            "frequency" : 0.04,
            "emitterLifetime" : 1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : 570,
                "y" : -90,
                "r" : 50
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.1
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 6
            },
            "blendMode" : "normal",
            "frequency" : 0.04,
            "emitterLifetime" : 1.4,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : 360,
                "y" : 100,
                "r" : 100
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.1
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 8
            },
            "blendMode" : "normal",
            "frequency" : 0.01,
            "emitterLifetime" : 1.2,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : -300,
                "y" : 120,
                "r" : 150
            }
        }
    ];
    private _FREESPIN_configs:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.11
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#f0ab7d",
                "end" : "#f0ab7d"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 6
            },
            "blendMode" : "normal",
            "frequency" : 0.04,
            "emitterLifetime" : 1,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : 570,
                "y" : -90,
                "r" : 50
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.11
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#f0ab7d",
                "end" : "#f0ab7d"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 6
            },
            "blendMode" : "normal",
            "frequency" : 0.04,
            "emitterLifetime" : 1.4,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : 360,
                "y" : 100,
                "r" : 100
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.11
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#f0ab7d",
                "end" : "#f0ab7d"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 8
            },
            "blendMode" : "normal",
            "frequency" : 0.01,
            "emitterLifetime" : 1.2,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : -300,
                "y" : 120,
                "r" : 150
            }
        }
    ];
    private _FREESPIN_SUPER_configs:any[] = [
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.14
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#e85e0e",
                "end" : "#e85e0e"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 6
            },
            "blendMode" : "normal",
            "frequency" : 0.02,
            "emitterLifetime" : 1.4,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : 380,
                "y" : 0,
                "r" : 150
            }
        },
        {
            "alpha" : {
                "start" : 1,
                "end" : 0.14
            },
            "scale" : {
                "start" : 0.5,
                "end" : 1,
                "minimumScaleMultiplier" : 0.5
            },
            "color" : {
                "start" : "#e85e0e",
                "end" : "#e85e0e"
            },
            "speed" : {
                "start" : 150,
                "end" : 160,
                "minimumSpeedMultiplier" : 1
            },
            "acceleration" : {
                "x" : 100,
                "y" : -40
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 180,
                "max" : 330
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 150,
                "max" : 250
            },
            "lifetime" : {
                "min" : 3.5,
                "max" : 8
            },
            "blendMode" : "normal",
            "frequency" : 0.008,
            "emitterLifetime" : 1.2,
            "maxParticles" : 100,
            "pos" : {
                "x" : 0,
                "y" : 0
            },
            "addAtBack" : false,
            "spawnType" : "circle",
            "spawnCircle" : {
                "x" : -350,
                "y" : -20,
                "r" : 200
            }
        }
    ];

    constructor() {
        super();
    }

    public play(mode:string):void {
        const config:any[] = (<any>this)[`_${mode}_configs`];
        config.forEach(config => {
            const emitter = new Emitter(this, [
                ElGordosRevenge.assetLoader.getTextures("particles/spark_1")[0],
                ElGordosRevenge.assetLoader.getTextures("particles/spark_2")[0],
                ElGordosRevenge.assetLoader.getTextures("particles/spark_3")[0],
                ElGordosRevenge.assetLoader.getTextures("particles/spark_4")[0]
            ], config);
            ParticlesManager.addEmitter(emitter);
            TweenLite.to(this, emitter.emitterLifetime, {
                onComplete : () => {
                    ParticlesManager.queueRemoveEmitter(emitter);
                }
            });
        });
    }
}